module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              (_vm.showCouleurstrafe = true) && (_vm.neuCouleurstrafe = true) && (_vm.couleurstrafe = _vm.couleurstrafeVorlage)
            }
          }
        }, [_c('v-icon', [_vm._v("add")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Erstellen")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "disabled": ""
          }
        }, on), [_c('v-icon', [_vm._v("save_alt")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Exportieren")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "disabled": ""
          }
        }, on), [_c('v-icon', [_vm._v("delete")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Löschen")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Suchen",
      "single-line": "",
      "solo": "",
      "flat": "",
      "hide-details": "",
      "clearable": "",
      "clear-icon": "close"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "10",
      "offset-lg": "1"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "dense": "",
      "height": _vm.sideHeight,
      "headers": _vm.headers,
      "items": _vm.couleurstrafen,
      "search": _vm.search,
      "fixed-header": "",
      "hide-default-footer": "",
      "items-per-page": -1,
      "hide-default-header": _vm.$vuetify.breakpoint.xsOnly,
      "no-data-text": "Keine Couleurstrafen eingetragen"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$filters.date(item.datum, "DD.MM.YYYY")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.titel))]), _vm._v(" "), (item.strafen) ? _c('td', [_vm._v(_vm._s(item.strafen.length) + " Strafen")]) : _c('td', [_vm._v("Keine Strafen")]), _vm._v(" "), _c('td', [_c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              (_vm.couleurstrafe = item) && (_vm.showCouleurstrafe = true) && (_vm.neuCouleurstrafe = false)
            }
          }
        }, [_c('v-icon', [_vm._v("edit")])], 1)], 1)])]
      }
    }, {
      key: "footer",
      fn: function() {
        return [_c('v-divider'), _vm._v(" "), _c('v-row', {
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-spacer'), _vm._v(" "), _c('div', {
          staticClass: "subtitle-2 mt-2 mb-2 mr-6"
        }, [_vm._v("Summe offene Strafen: " + _vm._s(_vm._f("money")(_vm.summe)))])], 1)]
      },
      proxy: true
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "width": "50%",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showCouleurstrafe),
      callback: function($$v) {
        _vm.showCouleurstrafe = $$v
      },
      expression: "showCouleurstrafe"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-card-title', [(_vm.neuCouleurstrafe) ? _c('div', {
    staticClass: "pr-1"
  }, [_vm._v("Neue Couleurstrafe erstellen")]) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.couleurstrafe.titel) + " - " + _vm._s(_vm.$filters.date(_vm.couleurstrafe.datum, "DD.MM.YYYY")) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showCouleurstrafe = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Titel"
    },
    model: {
      value: (_vm.couleurstrafe.titel),
      callback: function($$v) {
        _vm.$set(_vm.couleurstrafe, "titel", $$v)
      },
      expression: "couleurstrafe.titel"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "dense": "",
            "outlined": "",
            "hide-details": "",
            "label": "Datum",
            "readonly": "",
            "locale": "de-de"
          },
          model: {
            value: (_vm.formatDatum),
            callback: function($$v) {
              _vm.formatDatum = $$v
            },
            expression: "formatDatum"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu1),
      callback: function($$v) {
        _vm.menu1 = $$v
      },
      expression: "menu1"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.couleurstrafe.datum),
      callback: function($$v) {
        _vm.$set(_vm.couleurstrafe, "datum", $$v)
      },
      expression: "couleurstrafe.datum"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "items": _vm.selectBbrbbr,
      "label": "Wer"
    },
    model: {
      value: (_vm.newEintragCouleurstrafe.wer),
      callback: function($$v) {
        _vm.$set(_vm.newEintragCouleurstrafe, "wer", $$v)
      },
      expression: "newEintragCouleurstrafe.wer"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Betrag",
      "type": "number"
    },
    model: {
      value: (_vm.newEintragCouleurstrafe.betrag),
      callback: function($$v) {
        _vm.$set(_vm.newEintragCouleurstrafe, "betrag", $$v)
      },
      expression: "newEintragCouleurstrafe.betrag"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "1"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.addEintragCouleurstrafe()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-simple-table', {
    staticClass: "mb-0",
    attrs: {
      "fixed-header": "",
      "dense": ""
    }
  }, [(_vm.couleurstrafe.strafen) ? _c('tbody', _vm._l((_vm.couleurstrafe.strafen), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item.wer, _vm.bbrbbr)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.betrag)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(item.bezahlt) ? _c('v-label', {
      attrs: {
        "chip": "",
        "color": "green"
      }
    }, [_vm._v("Bezahlt")]) : _vm._e()], 1), _vm._v(" "), _c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteEintragCouleurstrafe(index)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)])
  }), 0) : _vm._e()])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [(!_vm.neuCouleurstrafe) ? _c('v-btn', _vm._g({
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showDeleteCouleurstrafe = true
      }
    }
  }, _vm.on), [_c('v-icon', [_vm._v("delete")])], 1) : _vm._e(), _vm._v(" "), (_vm.neuCouleurstrafe) ? _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showCouleurstrafe = false
      }
    }
  }, [_vm._v("Abbrechen")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.neuCouleurstrafe) ? _c('v-btn', {
    class: _vm.couleurstrafe.strafen.length > 0 ? 'primary' : '',
    attrs: {
      "disabled": _vm.couleurstrafe.strafen.length === 0,
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.createCouleurstrafe()
      }
    }
  }, [_vm._v("Speichern")]) : _c('v-btn', {
    class: _vm.couleurstrafe.strafen.length > 0 ? 'primary' : '',
    attrs: {
      "disabled": _vm.couleurstrafe.strafen.length === 0,
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateCouleurstrafe()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1)], 1), _vm._v(" "), _c('dialogDelete', {
    attrs: {
      "visible": _vm.showDeleteCouleurstrafe,
      "title": "Eintrag löschen",
      "message": "Willst du diesen Eintrag wirklich löschen?",
      "abbrechen": "Abbrechen",
      "weiter": "Löschen"
    },
    on: {
      "update:visible": function($event) {
        _vm.showDeleteCouleurstrafe = $event
      },
      "closeTrue": function($event) {
        return _vm.deleteCouleurstrafe()
      },
      "closeFalse": function($event) {
        _vm.showDeleteCouleurstrafe = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7179690c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/couleurstrafen.vue
// module id = 790
// module chunks = 15